import { useState } from "react";
import { Clock, Search, ChevronLeft, Sparkles, Activity, HandHeart, MessageCircle, Check } from "lucide-react";
import { money } from "../../lib/helpers";
import { Input } from "../../components/ui/input";

const ORDER = ["Aesthetics", "Osteopathy & Physiotherapy", "Massage", "Consultations"];
const ICONS = { Aesthetics: Sparkles, "Osteopathy & Physiotherapy": Activity, Massage: HandHeart, Consultations: MessageCircle };
const rank = (x) => (ORDER.includes(x) ? ORDER.indexOf(x) : ORDER.length);
const sectionOf = (s) => s.section || "Treatments";

function ServiceRow({ s, active, onPick, loc, lang, t }) {
  const p = s.prices[loc.id];
  return (
    <button onClick={onPick} data-testid={`book-service-${s.id}`}
      className={`lift w-full text-left rounded-[var(--radius)] border bg-card p-4 flex items-center gap-4 ${active ? "ring-2 ring-primary border-primary" : ""}`}>
      <div className="flex-1 min-w-0">
        <div className="font-semibold">{s.name}</div>
        <div className="text-sm text-muted-foreground flex flex-wrap gap-3"><span className="flex items-center gap-1"><Clock className="h-3.5 w-3.5" />{s.duration} {t("min")}</span>
          <span>{money(p.price, loc.currency, lang)}</span>{p.deposit > 0 && <span>{t("deposit")}: {money(p.deposit, loc.currency, lang)}</span>}</div>
        {s.description && <p className="text-sm mt-1">{s.description}</p>}
      </div>
      {active && <Check className="h-5 w-5 text-primary" />}
    </button>
  );
}

export function ServicePicker({ svcs, selected, onPick, loc, lang, t }) {
  const [sec, setSec] = useState(null);
  const [q, setQ] = useState("");
  const sections = [...new Set(svcs.map(sectionOf))].sort((a, b) => rank(a) - rank(b) || a.localeCompare(b));
  const needle = q.trim().toLowerCase();
  const showCards = sections.length > 1 && !sec && !needle;
  const list = svcs.filter((s) => (needle ? `${s.name} ${s.category}`.toLowerCase().includes(needle) : !sec || sectionOf(s) === sec));
  const cats = [...new Set(list.map((s) => s.category || ""))].sort();
  return (
    <div className="space-y-4" data-testid="service-picker">
      <div className="relative"><Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input data-testid="book-service-search" className="pl-9" placeholder="Search treatments" value={q} onChange={(e) => setQ(e.target.value)} /></div>
      {showCards ? <div className="grid sm:grid-cols-2 gap-3">{sections.map((name) => {
        const Icon = ICONS[name] || Sparkles;
        return (
          <button key={name} data-testid={`book-section-${name.toLowerCase().replace(/[^a-z]+/g, "-")}`} onClick={() => setSec(name)}
            className="lift text-left rounded-[var(--radius)] border bg-card p-5 flex items-center gap-4">
            <span className="h-11 w-11 rounded-full bg-primary/10 text-primary grid place-items-center shrink-0"><Icon className="h-5 w-5" /></span>
            <span><span className="block font-semibold">{name}</span><span className="text-sm text-muted-foreground">{svcs.filter((s) => sectionOf(s) === name).length} treatments</span></span>
          </button>);
      })}</div> : <>
        {sec && !needle && sections.length > 1 && <button className="text-sm text-primary flex items-center gap-1" data-testid="book-section-back" onClick={() => setSec(null)}><ChevronLeft className="h-4 w-4" />All treatment types</button>}
        {!list.length && <p className="text-sm text-muted-foreground" data-testid="book-service-none">No treatments found.</p>}
        {cats.map((c) => (
          <div key={c || "-"} className="space-y-2">
            {c && <h3 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground pt-2">{c}</h3>}
            {list.filter((s) => (s.category || "") === c).map((s) => <ServiceRow key={s.id} s={s} active={selected === s.id} onPick={() => onPick(s.id)} loc={loc} lang={lang} t={t} />)}
          </div>))}
      </>}
    </div>
  );
}
